var map = {
	"./ContextMenu.vue": "f62b",
	"./LoadingOverlay.vue": "389c",
	"./LoadingWidget.vue": "e4eb",
	"./Options.vue": "15da",
	"./PieChart.vue": "0f97",
	"./ShowMore.vue": "0bdc",
	"./SimpleSlide.vue": "07ba",
	"./Slideshow.vue": "fe1c",
	"./UserPicture.vue": "c70f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3a82";